import { render, staticRenderFns } from "./content.vue?vue&type=template&id=85e72e2a&"
import script from "./content.vue?vue&type=script&lang=ts&"
export * from "./content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports